import { showApiError, showSuccess } from "@/lib/toast";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addAllergy } from "@/sideEffects/api";
import { AllergyMetaForm, FormSchemaType } from "./form/AllergyMetaForm";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { ROUTES } from "@/constants/routeConstants";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { BaseFormLayout } from "../shared/BaseFormLayout";

export const AddNewAllergyPage = () => {
  const { t } = useTranslation();

  useBreadcrumbs([
    {
      name: t("entities.allergy"),
      path: ROUTES.ALLERGY,
    },
    {
      name: t("common.addNewEntity", { entity: t("entities.allergy") }),
      path: ROUTES.ALLERGY_ADD,
    },
  ]);

  const { goToAllergyDetail } = useAppNavigate();
  const queryClient = useQueryClient();
  const addAllergyMutation = useMutation({
    mutationFn: (values: FormSchemaType) => addAllergy(values.name),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["getAllergy"],
      });
      showSuccess(t("common.addedSuccess"));
      goToAllergyDetail(data.data.id);
    },
    onError: showApiError,
  });

  return (
    <BaseFormLayout title={t("common.addNewEntity", { entity: t("entities.allergy") })}>
      <AllergyMetaForm
        buttonText={t("common.add")}
        onSubmit={(values) => addAllergyMutation.mutate(values)}
        isLoading={addAllergyMutation.isPending}
      />
    </BaseFormLayout>
  );
};
